import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { filter, tap } from 'rxjs/operators';
import {
  GOOGLE_BUTTON_CONFIGURATIONS
} from 'app/shared/components/google-button/google-button-configurations.constants';
import { GoogleSignOnService } from './../../services/google-sign-on.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'kh-google-button',
    styleUrls: ['./google-button.component.less'],
    templateUrl: './google-button.component.html',
    standalone: false
})
export class GoogleButtonComponent implements AfterViewInit, OnInit {
  @Input() public ariaLabel = '';
  @Input() public buttonConfiguration = GOOGLE_BUTTON_CONFIGURATIONS.ICON;
  @Input() public buttonWidth?: number;
  @Input() public customClass = '';
  @Input() public isClickable = true;

  @Output() public clickInterrupted = new EventEmitter<void>();
  @Output() public loggedIn = new EventEmitter<string>();
  @ViewChild('buttonContainer') public buttonContainer!: ElementRef;

  private sourceId = Math.random().toString();

  public constructor(private readonly googleSignOnService: GoogleSignOnService) { }

  public ngOnInit(): void {
    this.googleSignOnService.getIdToken()
      .pipe(
        filter(data => data.sourceId === this.sourceId),
        tap(data => {
          this.loggedIn.emit(data.token);
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }

  public ngAfterViewInit(): void {
    let buttonConfig = {...this.buttonConfiguration};
    if (this.buttonWidth !== null) {
      buttonConfig = {
        ...this.buttonConfiguration,
        width: this.buttonWidth,
        logo_alignment: 'center'
      }
    }
    this.googleSignOnService.render(this.buttonContainer, buttonConfig, this.sourceId);
  }

  public onClickInterrupted(event: Event): void {
    this.clickInterrupted.emit();
  }
}
